<template>
	<div>
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><i class="fa fa-paper-plane fa-13"></i> ตั้งค่าผู้ส่ง</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12 col-md-12">
				<div class="row">
					<div class="col-12 col-md-4 py-1 px-2">
						<router-link to="Setupsender">
							<button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-angle-double-left"></i> ย้อนกลับ</button>
						</router-link>
						เพิ่มผู้ส่งใหม่
					</div>
				</div>
				<div class="row">
					<div class="col-12 py-1">
						<div class="bg-blue font14">
							<div>1. ชื่อผู้ส่งจะต้องเป็นภาษาอังกฤษ และ มีความยาวตัวอักษรไม่เกิน 11 ตัว</div>
							<div>2. การเปลี่ยนแปลงชื่อผู้ส่งจะใช้เวลาประมาณ 1 วันทำการ</div>
							<div>3. ระบบจะส่งคำยืนยันไปยังโทรศัพท์ท่านโดยใช้เครดิตในการส่ง SMS ของท่าน1 เครดิตต่อการเปลี่ยน 1 ครั้ง</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center mt-3">
					<div class="col-12 col-md-8">
						<div class="border-detail">
							<div class="row justify-content-center py-4">
								<div class="col-12 col-md-8 px-4">
									ชื่อผู้ส่ง
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon">
												<mdb-icon far icon="edit" />
											</span>
										</div>
										<input type="text" v-model="payload.sender_name" class="form-control" aria-describedby="basic-addon" @keypress="isCharacter($event)" />
									</div>
								</div>
								<div class="col-12 col-md-8 px-4 mt-4">
									<!-- <span class="mr-4">White List</span>
									<div class="form-check form-check-inline">
										<input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample" checked />
										<label class="form-check-label pl-4 pr-2" for="materialInline1">Yes</label>
									</div>
									<div class="form-check form-check-inline">
										<input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample" />
										<label class="form-check-label pl-4" for="materialInline2">No</label>
									</div> -->

									<mdb-form-inline>
										<span class="mr-4">White List</span>
										<mdb-input type="radio" id="option5-1" class="d-none" name="groupOfMaterialRadios2" radioValue="Yes" v-model="payload.white_list" label="Yes" />
										<mdb-input type="radio" id="option5-2" name="groupOfMaterialRadios2" radioValue="No" v-model="payload.white_list" label="No" checked/>
									</mdb-form-inline>
								</div>
								<div class="col-12 col-md-8 text-center mt-4">
									<button type="button" class="btn btn-Send-Request color_white mr-3 font14" style="font-weight:400;" @click="SaveOnClick()"><mdb-icon icon="check" /> ตกลง</button>
									<router-link to="Setupsender">
										<button type="button" class="btn btn-cancel color_white font14" style="font-weight:400;"><i class="fas fa-times"></i> ยกเลิก</button>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import $ from 'jquery'
	// import moment from 'moment'
	import {mapGetters, mapActions} from 'vuex'
	// const jwt = require('jsonwebtoken')
	export default {
		name: 'Setupsenderadd',
		data() {
			return {
				payload: {
					sender_name: '',
					white_list: 'Yes',
				},
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			isCharacter: function(evt) {
				evt = evt ? evt : window.event
				var charCode = evt.which ? evt.which : evt.keyCode
				if (charCode < 32 || (charCode > 33 && charCode < 45) || (charCode > 46 && charCode < 48) || (charCode > 57 && charCode < 65) || (charCode > 90 && charCode < 97) || (charCode > 122 && charCode == 32) || (charCode > 3584)) {
					evt.preventDefault()
				} else {
					return true
				}
			},
			SaveOnClick() {
				if (this.payload.sender_name == '') {
					return this.$swal({
						html: '<i class="fa fa-user-circle fa-6x"></i><br><br>กรุณากรอกชื่อผู้ส่ง<br>',
						timer: 8000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				this.callApiMotherFucker({
					method: 'PUT',
					path: '/sender',
					data: this.payload,
				}).then((res) => {
					if (res.code == 0) {
						this.$swal({
							icon: 'success',
							html: res.msg,
							timer: 8000,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						})
						this.$router.push('/Setupsender')
					} else {
						this.$swal({
							icon: 'error',
							html: res.msg,
							timer: 8000,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						})
						this.$router.push('/Setupsender')
					}
				})
			},
		},
		mounted() {},
	}
</script>
<style scoped>
	.fa-13 {
		font-size: 1em;
	}
	.field-icon {
		margin-left: 25px;
		margin-right: 10px;
		margin-top: 0px;
		position: relative;
		z-index: 2;
	}
	.border-detail {
		border: 1px solid #cccccc;
		box-sizing: border-box;
		border-radius: 5px;
		padding: 10px;
	}
	.hr-horizontal {
		border: 1px solid #cccccc;
		margin-right: -15px;
		margin-left: -15px;
	}
</style>
